export const setApiErr = (err: { state: number; message: string }) => {
  return {
    type: 'SETAPIERROR',
    payload: err,
  }
}
